import type { FC } from "react";

import {
  TABS_DEFAULTS,
  type TTabsProps,
} from "@/ui/components/navigation/Tabs/Tabs.config";
import { TabsContent } from "@/ui/components/navigation/Tabs/TabsContent";
import { TabsList } from "@/ui/components/navigation/Tabs/TabsList";
import { TabsLinks } from "@/ui/components/navigation/Tabs/TabsLinks";
import { TabsRoot } from "@/ui/components/navigation/Tabs/TabsRoot";
import { TabsTriggers } from "@/ui/components/navigation/Tabs/TabsTriggers";
import { cn } from "@/ui/lib/utils";

export const Tabs: FC<TTabsProps> = (tabsProps) => {
  const {
    className,
    contentClassName,
    defaultValue,
    links,
    listClassName,
    tabs,
    triggerClassName,
    value,
    variant: configuredVariant,
    hideTabList = TABS_DEFAULTS.hideTabList,
    ...props
  } = tabsProps;
  const variant = configuredVariant ?? TABS_DEFAULTS.variant;

  return (
    <TabsRoot
      data-component="Tabs"
      className={cn("w-full", className)}
      defaultValue={defaultValue ?? value ?? tabs[0]?.value}
      value={value}
      {...props}
    >
      <TabsList
        variant={variant}
        className={listClassName}
        hidden={hideTabList}
      >
        <TabsTriggers
          {...tabsProps}
          triggerClassName={triggerClassName}
        />
        <TabsLinks links={links} />
      </TabsList>
      { tabs.map((tab) => (
        <TabsContent
          key={tab.value}
          value={tab.value}
          variant={variant}
          className={contentClassName}
        >
          { tab.content }
        </TabsContent>
      )) }
    </TabsRoot>
  );
};

Tabs.displayName = "Tabs";
